// extracted by mini-css-extract-plugin
export default {"ModeratorInvitationListItem":"bch_a bhi_a bhi_r bhi_j","ModeratorInvitationListItem__left":"bch_b bhi_a bhi_j","ModeratorInvitationListItem__note":"bch_c bhi_fm"};